import React, {useState } from 'react'
import { Row, Col, Input, Button } from 'antd'
import classes from "./css/Search.module.css"
import { useTranslation } from "react-i18next"
import { SearchOutlined, HeartOutlined } from '@ant-design/icons'
import { Link } from 'react-router-dom'
import { useNavigate } from "react-router-dom"

import { useDispatch } from 'react-redux'
import { KeySearchRedux } from '../../../redux/mapPage/search'



const Search: React.FC = () => {

  const { t } = useTranslation()
  const [stringTemp, setStringTemp] = useState<string>("")
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const handleKeypress = (e : React.KeyboardEvent<HTMLInputElement>) => {
  
    if (e.key === 'Enter') {
      dispatch(KeySearchRedux(stringTemp))
      navigate(`/search`, { replace: false })
    }
  };

  // const SearchInputs = () => {
  //   return (
  //     <Row justify="center">
  //       <Col xs={{ span:22 }} lg={{ span:16 }}>
  //         <div className={classes.line}>
  //           <Input
  //             placeholder={t("Εισάγετε ένα όρο αναζήτησης") || ''}
  //             prefix={<SearchOutlined />}
  //             className={classes.input}
  //             onChange={(e)=> setStringTemp(e.target.value) }
  //           />
  //           <Button
  //             type="primary"
  //             className={classes.searchBtn}
  //             onClick={() => [dispatch(KeySearchRedux(stringTemp)), navigate(`/search`, { replace: false })]}>
  //             {t("Αναζήτηση")}
  //           </Button>
  //         </div>
  //       </Col>
  //     </Row>
  //   )
  // }


  return (
    <>
      <div className={classes.containerBg}>
      <div className={classes.container}>
        
        <Row justify="center">
          <Col xs={24} sm={24} md={4} lg={{ span: 4 }} >
            <div className={classes.center} >
              <hr className={classes.hr} />
            </div>
          </Col>
          <Col xs={24} sm={24} md={16} lg={16}>
            <div className={classes.title}>
              {t('Search_Title')}
            </div>
          </Col>
          <Col lg={4}> </Col>
        </Row>

        {/* <SearchInputs /> */}

        <Row justify="center">
          <Col xs={{ span:22 }} lg={{ span:16 }}>
            <div className={classes.line}>
              <Input
                placeholder={t("Εισάγετε ένα όρο αναζήτησης") || ''}
                prefix={<SearchOutlined />}
                className={classes.input}
                onChange={(e) => setStringTemp(e.target.value)}
                onKeyPress={handleKeypress}
              />
              <Button
                type="primary"
                className={classes.searchBtn}
                onClick={() => [dispatch(KeySearchRedux(stringTemp)), navigate(`/search`, { replace: false })]}>
                {t("Αναζήτηση")}
              </Button>
            </div>
          </Col>
        </Row>

          
          
        <Row justify="center">
          <Col xs={{ span:22 }} lg={{ span:16 }}>
            <div className={classes.subTitle}>
            <HeartOutlined /> {t('Search_SubTitle')}
            </div>
          </Col>
        </Row>        
        <Row justify="center">
          <Col xs={{ span:22 }} lg={{ span:16 }}>
            <Button type="primary" className={classes.popularBtn}><Link to="/exploration/1_48">{ t('Σαμαριά') }</Link></Button>
            <Button type="primary" className={classes.popularBtn}><Link to="/exploration/1_430">{ t('Φάρος Χανίων') }</Link></Button>
            <Button type="primary" className={classes.popularBtn}><Link to="/exploration/1_278">{ t('Λουτρό') }</Link></Button>
            <Button type="primary" className={classes.popularBtn}><Link to="/exploration/1_444">{ t('Σαρακίνικο Γαύδου') }</Link></Button>
          </Col>
          <Col xs={{ span:22 }} lg={{ span:16 }}>
            <Button type="primary" className={classes.popularBtn}><Link to="/exploration/1_358">{ t('Μπάλος') }</Link></Button>
            <Button type="primary" className={classes.popularBtn}><Link to="/exploration/1_470">{ t('Αρχαιολογικό Μουσείο Χανίων') }</Link></Button>
            <Button type="primary" className={classes.popularBtn}><Link to="/exploration/1_1">{ t('Λίμνη Κουρνά') }</Link></Button>
            <Button type="primary" className={classes.popularBtn}><Link to="/exploration/1_240">{ t('Παλαιοχώρα') }</Link></Button>
          </Col>
        </Row>
        
        </div>
        </div>
    </>
  )
}

export default Search